import axiosInstance from '@/api/axiosInstance';
import { FetchBundlesParams, FetchBundlesResponse } from '../types';

/**
 * Fetch published programs for catalog
 */
export async function fetchBundles(
  params: FetchBundlesParams = {}
): Promise<FetchBundlesResponse> {
  const queryParams = new URLSearchParams();

  if (params.page) {
    queryParams.set('page', params.page.toString());
  }
  if (params.limit) {
    queryParams.set('limit', params.limit.toString());
  }
  if (params.search) {
    queryParams.set('search', params.search);
  }

  const queryString = queryParams.toString();
  const url = `/api/programs${queryString ? `?${queryString}` : ''}`;

  const response = await axiosInstance.get<FetchBundlesResponse>(url);
  return response.data;
}

export default fetchBundles;
